var Api = require('./api');

var configPromise = require('../config').configPromise;

var NEWS_URL = '/api/news';

var NewsApi = {

  getNews: function () {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(NEWS_URL));
      });
  }

};

module.exports = NewsApi;
